import { NullableFormValue, ValueConverter } from "../index";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";


class NumberConverter implements ValueConverter<string, number> {
	toData( inp: NullableFormValue<string, number> ): NullableFormValue<string, number> {
		if ( inp != null ) {
			if ( typeof inp == "number" ) return inp;
			else {
				let text = inp.toString();
				text = text.replace( /[^0-9]*/g, "" );
				return !isEmptyStringOrNull( text ) ? Number( text ) : undefined;
			}
		}
		return inp;
	}

	fromData( inp: NullableFormValue<string, number> ): NullableFormValue<string, number> {
		if ( inp != null ) {
			if ( typeof inp == "number" ) return inp + "";
			else {
				let text = inp.toString();
				text = text.replace( /[^0-9]*/g, "" );
				return text;
			}
		}
		return inp;
	}
}

const Converter = new NumberConverter();
export default Converter;
